import { render, staticRenderFns } from "./ptBtn.vue?vue&type=template&id=33bbf639&scoped=true&"
import script from "./ptBtn.vue?vue&type=script&lang=js&"
export * from "./ptBtn.vue?vue&type=script&lang=js&"
import style0 from "./ptBtn.vue?vue&type=style&index=0&id=33bbf639&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bbf639",
  null
  
)

export default component.exports